module.exports = __webpack_public_path__ + "static/media/ufc-logo-white-min.77db1861.png";